/* ============================================================
   NOVARA WELLNESS — Animations & Interactions
   ============================================================ */

// ── Scroll Fade-Up Animations ──────────────────────────────
(function initReveal() {
  const els = Array.from(document.querySelectorAll('.animate'));
  if (!els.length) return;

  const revealAll = () => els.forEach((e) => e.classList.add('visible'));

  if (!('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  const animObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          animObserver.unobserve(e.target);
        }
      });
    },
    { threshold: 0.1 }
  );
  els.forEach((el) => animObserver.observe(el));

  // Safety net. If nothing has resolved shortly after load — zero-height
  // viewport, a non-compositing context, a headless render — show the page
  // rather than leaving it blank. Content must never depend on the observer.
  setTimeout(() => {
    if (!document.querySelector('.animate.visible')) revealAll();
  }, 400);
})();

// ── Nav Scroll Behavior ────────────────────────────────────
(function initNavScroll() {
  const nav = document.querySelector('.novara-header');
  if (!nav) return;

  const onScroll = () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run once on load
})();

// ── Mobile Nav ──────────────────────────────────────────────
(function initMobileNav() {
  const toggle = document.querySelector('.novara-mobile-toggle');
  const close  = document.querySelector('.novara-mobile-nav-close');
  const mobileNav = document.querySelector('.novara-mobile-nav');

  if (!toggle || !mobileNav) return;

  toggle.addEventListener('click', () => {
    mobileNav.classList.add('open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  });

  const closeNav = () => {
    mobileNav.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileNav.classList.contains('open')) closeNav();
  });

  if (close) close.addEventListener('click', closeNav);

  mobileNav.querySelectorAll('a').forEach((a) => a.addEventListener('click', closeNav));
})();

// ── Variant Selector (product cards) ──────────────────────
(function initVariantSelectors() {
  document.querySelectorAll('.novara-variant-select').forEach((sel) => {
    sel.addEventListener('change', function () {
      const card = this.closest('.novara-product-card');
      if (!card) return;

      const priceEl   = card.querySelector('.novara-card-price');
      const addBtn    = card.querySelector('.novara-card-btn[data-add-to-cart]');
      const variantId = this.value;

      if (priceEl) {
        const opt = this.options[this.selectedIndex];
        priceEl.textContent = opt.dataset.price || priceEl.textContent;
      }
      if (addBtn) addBtn.dataset.variantId = variantId;
    });
  });
})();

// ── Add to Cart ────────────────────────────────────────────
(function initAddToCart() {
  document.querySelectorAll('[data-add-to-cart]').forEach((btn) => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();

      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const originalText = this.textContent;
      this.textContent = 'Adding...';
      this.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        if (res.ok) {
          this.textContent = 'Added ✓';
          setTimeout(() => {
            this.textContent = originalText;
            this.disabled = false;
          }, 2000);

          updateCartCount();
        } else {
          throw new Error('Add failed');
        }
      } catch {
        this.textContent = originalText;
        this.disabled = false;
      }
    });
  });
})();

// ── Cart Count ─────────────────────────────────────────────
function updateCartCount() {
  fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      const count = cart.item_count;
      // Novara header cart link
      const novaraCount = document.querySelector('.novara-cart-count');
      if (novaraCount) {
        novaraCount.textContent = count > 0 ? `(${count})` : '';
      }
      // Dawn's bubble (if present)
      const dawnBubble = document.querySelector('.cart-count-bubble span:last-child');
      if (dawnBubble) dawnBubble.textContent = count;
      // Dispatch for any Dawn web components listening
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
}

// Run on page load to sync count
updateCartCount();

// ── Newsletter Form ─────────────────────────────────────────
// Submits natively to Shopify's /contact endpoint. Do not intercept and fake
// a success state — that shows "Subscribed" while capturing nothing.
(function initNewsletter() {
  const form = document.querySelector('.novara-newsletter-form');
  if (!form) return;

  form.addEventListener('submit', function () {
    const btn = this.querySelector('button[type="submit"]');
    if (btn) {
      btn.textContent = 'Subscribing…';
      btn.disabled = true;
    }
  });
})();
